module.exports = __webpack_public_path__ + "img/3-low.6dc6b6a8.jpg";